import React, { useEffect, useMemo, useState } from 'react';
import { Calendar, CalendarDayInfo } from '../model/Calendar';

export function CalendarWidget({ selected, calendar, onPrevMonth, onNextMonth, isDateEnabled, onSelect }: { selected: CalendarDayInfo | null, calendar: Calendar, onPrevMonth: () => void, onNextMonth: () => void, isDateEnabled: (date_data: CalendarDayInfo) => boolean, onSelect: (date_data: CalendarDayInfo) => void })
{
    return (
        <div className="calendar-container">
            <div className="calendar-header">
                { <h3><button onClick={onPrevMonth}>&lt;&lt;</button>{ calendar.month_name }<button onClick={onNextMonth}>&gt;&gt;</button></h3> }
            </div>
            <table className="calendar">
                <tr>
                    { calendar.columns.map(col => <th>{ col }</th>) }
                </tr>
            {
            calendar.rows.map((row) => 
                <tr>   
                {row.map(cell => {
                    let enabled = isDateEnabled(cell);
                    return (
                    <td className={"calendar_cell" + (enabled ? " available-slot" : " disabled-slot") + (selected?.date == cell.date ? " selected" : "") }>
                        { enabled ? <button onClick={() => onSelect(cell)}>{ cell.name }</button> : <span>{ cell.name }</span> }
                    </td>
                    )
                })}
                </tr>
            )
            }
            </table>
        </div>
    )
}
